<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header
                    :title="$t('adjunct_payments')"
                    :isNewButton="checkPermission('adjunctpayment_store')"
                    :isColumns="true"
                    @new-button-click="createFormShow()"
                    @filter-div-status="datatable.filterStatus = $event"
                >
                    <template v-slot:columns>
                        <div
                            class="mb-1"
                            v-for="(column, key) in datatable.columns"
                        >
                            <b-form-checkbox
                                :id="'checkbox-' + key"
                                :name="'checkbox-' + key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field != 'buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile
                    :title="$t('adjunct_payments')"
                    :isNewButton="checkPermission('adjunctpayment_store')"
                    :isColumns="true"
                    @new-button-click="createFormShow()"
                    @filter-div-status="datatable.filterStatus = $event"
                >
                    <template v-slot:columns>
                        <div
                            class="mb-1"
                            v-for="(column, key) in datatable.columns"
                        >
                            <b-form-checkbox
                                :id="'checkbox-' + key"
                                :name="'checkbox-' + key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field != 'buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
            <datatable-filter
                v-show="datatable.filterStatus"
                @filter="filter"
                @filterClear="filterClear"
            >
                <b-row>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('teaching_staff')">
                            <staff-auto-complete
                                v-model="
                                    datatable.queryParams.filter.instructor_id
                                "
                            ></staff-auto-complete>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group
                            :label="$t('academic_year') + '/' + $t('semester')"
                        >
                            <semesters-selectbox
                                v-model="
                                    datatable.queryParams.filter.semester_id
                                "
                            ></semesters-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4"> </b-col>
                    <b-col cols="12" md="6" lg="4"> </b-col>
                    <b-col cols="12" md="6" lg="4"> </b-col>
                </b-row>
            </datatable-filter>
            <datatable
                :isLoading.sync="datatable.isLoading"
                :columns="datatable.columns"
                :rows="datatable.rows"
                :total="datatable.total"
                :queryParams="datatable.queryParams"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable"
            >
            </datatable>

            <CommonModal
                ref="showModal"
                size="xl"
                :onHideOnlyX="true"
                @bHideModalHeaderClose="formClear()"
                v-if="checkPermission('adjunctpayment_show')"
            >
                <template v-slot:CommonModalTitle>
                    {{ $t("score_information").toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <show-form :formId="formId" v-if="formProcess == 'show'" />
                </template>
            </CommonModal>

            <CommonModal
                ref="createFormModal"
                size="xl"
                :onHideOnlyX="true"
                @bHideModalHeaderClose="formClear"
                v-if="checkPermission('adjunctpayment_store')"
            >
                <template v-slot:CommonModalTitle>
                    {{ $t("new").toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form
                        @createFormSuccess="createFormSuccess"
                        v-if="formProcess == 'create'"
                    />
                </template>
            </CommonModal>

            <CommonModal
                ref="updateFormModal"
                size="xl"
                :onHideOnlyX="true"
                @bHideModalHeaderClose="formClear"
                v-if="checkPermission('adjunctpayment_update')"
            >
                <template v-slot:CommonModalTitle>
                    {{ $t("edit").toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form
                        :formId="formId"
                        @updateFormSuccess="updateFormSuccess"
                        v-if="formProcess == 'update'"
                    />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

// Components
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import CommonModal from "@/components/elements/CommonModal";
import StaffAutoComplete from "@/components/interactive-fields/StaffAutoComplete";
import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox";

// Pages
import CreateForm from "./CreateForm";
import UpdateForm from "./UpdateForm";
import ShowForm from "./ShowForm";

// Services
import AdjunctPaymentService from "@/services/AdjunctPaymentService";

// Others
import qs from "qs";
import moment from "moment";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        DatatableFilter,
        Datatable,

        ShowForm,
        CreateForm,
        UpdateForm,

        CommonModal,

        StaffAutoComplete,
        SemestersSelectbox,
    },
    metaInfo() {
        return {
            title: this.$t("adjunct_payments"),
        };
    },
    data() {
        return {
            statusData: [
                { value: null, text: "" },
                { value: "a", text: this.$t("active") },
                { value: "p", text: this.$t("passive") },
            ],
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: "",
                        field: "buttons",
                        html: true,
                        sortable: false,
                        tdClass: "p-0 text-center w-40 align-middle",
                        buttons: [
                            {
                                text: this.$t("show"),
                                class: "ri-search-eye-line",
                                permission: "adjunctpayment_show",
                                callback: (row) => {
                                    this.showForm(row.id);
                                },
                            },
                            {
                                text: this.$t("edit"),
                                class: "ri-edit-box-line",
                                permission: "adjunctpayment_update",
                                callback: (row) => {
                                    this.updateFormShow(row.id);
                                },
                            },
                            {
                                text: this.$t("delete"),
                                class: "ri-delete-bin-2-line",
                                permission: "adjunctpayment_delete",
                                callback: (row) => {
                                    this.formDelete(row.id);
                                },
                            },
                        ],
                    },
                    {
                        label: this.toUpperCase("id"),
                        field: "id",
                        hidden: true,
                    },

                    {
                        label: this.toUpperCase("teaching_staff"),
                        field: "instructor_name",
                        hidden: false,
                        formatFn: (value, row) => {
                            return row.instructor_name + " " + row.instructor_surname;
                        },
                    },
                    {
                        label: this.toUpperCase("semester"),
                        field: "semester",
                        formatFn: (row, value) => {
                            return value.academic_year + ' / ' + value.semester;
                        },
                        hidden: false
                    },
                    {
                        label: this.toUpperCase("amount"),
                        field: "amount",
                        hidden: false,
                        formatFn: (value, row) => {
                           return parseFloat(row.amount).toFixed(2) + ' ' + row.currency;
                        },
                    },
                    {
                        label: this.toUpperCase("comments"),
                        field: "explanation",
                        hidden: false,
                    },

                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: "id",
                    page: 1,
                    limit: 20,
                },
            },
            formProcess: null,
            formId: null,
            form: {},
        };
    },
    created() {
        this.filterSet();
        this.formClear();
    },
    methods: {
        filterSet() {
            this.datatable.queryParams.filter = {};
        },
        filterClear() {
            this.filterSet();
            this.getRows();
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == "desc" ? "-" : "";
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams,
                },
                paramsSerializer: (params) =>
                    qs.stringify(params, { encode: false }),
            };

            return AdjunctPaymentService.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;

                    this.datatable.rows.forEach(
                        (c) =>
                            (c.status =
                                c.status == "a"
                                    ? this.$t("active")
                                    : this.$t("passive"))
                    );
                    this.datatable.rows.forEach(
                        (c) =>
                            (c.updated_at = moment(c.updated_at).format(
                                "DD.MM.YYYY"
                            ))
                    );
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },

        // Clear
        formClear() {
            this.formId = null;
            this.formProcess = null;
        },

        // Create
        createFormShow() {
            this.formId = null;
            this.formProcess = "create";
            this.$refs.createFormModal.$refs.commonModal.show();
        },
        createFormSuccess() {
            this.$refs.createFormModal.$refs.commonModal.hide();
            this.getRows();
            this.formClear();
        },
        // Show
        showForm(id) {
            this.formId = id;
            this.formProcess = "show";
            this.$refs.showModal.$refs.commonModal.show();
        },

        // Update
        updateFormShow(id) {
            this.formId = id;
            this.formProcess = "update";
            this.$refs.updateFormModal.$refs.commonModal.show();
        },
        updateFormSuccess() {
            this.$refs.updateFormModal.$refs.commonModal.hide();
            this.getRows();
            this.formClear();
        },

        formDelete(id) {
            this.$swal
                .fire({
                    text: this.$t("are_you_sure_to_delete"),
                    showCancelButton: true,
                    confirmButtonText: this.$t("yes"),
                    cancelButtonText: this.$t("no"),
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        AdjunctPaymentService.del(id)
                            .then((response) => {
                                this.$toast.success(
                                    this.$t("api." + response.data.message)
                                );
                                this.getRows();
                                this.formClear();
                            })
                            .catch((error) => {
                                this.$toast.error(
                                    this.$t("api." + error.data.message)
                                );
                            });
                    }
                });
        },
    },
};
</script>
